"use client";

import { useTranslations } from "next-intl";
import { useAccount, useChainId, useSwitchChain } from "wagmi";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { EXPECTED_CHAIN } from "@/configs/expected-chain";
// BUG-11-CHG-01: stays on raw useAccount. Network-detection UI — modal triggers when actual connected wallet's chain mismatches expected network. Target wallet's network is irrelevant; we read chain from impersonator's wallet always.
import { usePathname } from "@/i18n/navigation";

export const NetworkCheckModal = () => {
  const t = useTranslations("modals");
  const { address } = useAccount();
  const chainId = useChainId();
  const { switchChain, chains } = useSwitchChain();
  const pathname = usePathname();

  const expectedChain = EXPECTED_CHAIN;

  const isBridgePage = pathname?.includes("bridge");

  // Find current chain name for display
  const currentChain = chains.find((c) => c.id === chainId);

  const shouldShowModal =
    !!address && !isBridgePage && chainId !== expectedChain.id;

  return (
    <Dialog open={shouldShowModal} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-xs space-y-4 px-9"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="w-full">
          <DialogTitle>{t("networkCheck.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm text-text-primary font-normal">
          {t("networkCheck.message", {
            current: currentChain?.name ?? "Unknown Network",
            expected: expectedChain.name,
          })}
        </DialogDescription>
        <DialogFooter className="w-full">
          <div className="w-full flex justify-center">
            <Button
              colors="secondary"
              className="w-fit"
              onClick={() => switchChain({ chainId: expectedChain.id })}
            >
              {t("networkCheck.switchButton")}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
